module.exports = "/legacy/13c8d1aa17ce7ae226531ffb34303e38.svg";